<script>
export default {
    inheritAttrs: false
}
</script>

<script setup>
import { computed } from 'vue';
import { twMerge } from 'tailwind-merge';
import { useAttrs } from 'vue';

const attrs = useAttrs();

const props = defineProps({
    rating: {
        type: Number,
        required: true,
        validator: (value) => value >= 0 && value <= 5
    }
});

const stars = computed(() => {
    return Array.from({ length: 5 }, (_, index) => {
        const starValue = index + 1;
        const fillPercentage = Math.max(0, Math.min(100, (props.rating - index) * 100));
        return {
            value: starValue,
            fillPercentage
        };
    });
});

const attrClass = computed(() => attrs.class);
const restAttrs = computed(() => {
    const { class: _, ...rest } = attrs;
    return rest;
});
</script>

<template>
    <div :class="twMerge('flex items-center h-4', attrClass)" v-bind="restAttrs">
        <div v-for="star in stars" :key="star.value" class="relative h-full">
            <!-- Outline star -->
            <svg class="h-full aspect-square text-gray-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
            </svg>
            <!-- Filled star -->
            <div class="absolute inset-0 overflow-hidden" :style="{ width: `${star.fillPercentage}%` }">
                <svg class="h-full aspect-square text-yellow-400" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>
            </div>
        </div>
    </div>
</template>

<style scoped>
.relative {
    position: relative;
    display: inline-block;
    margin-right: 0.25rem;
}

.absolute {
    position: absolute;
    top: 0;
    left: 0;
}

.overflow-hidden {
    overflow: hidden;
}
</style>
